<template>
    <div class="flex flex-col items-center gap-10 w-full max-w-3xl">
        <div class="text-center leading-tight">
            <h2 class="max-w-2xl display-medium text-balance mb-4">{{ t("onboarding.evaluator.contextDeepDive.title") }}</h2>
            <p class="text-ink-muted body md:display-serif max-w-xl mx-auto text-pretty">{{ t("onboarding.evaluator.contextDeepDive.subtitle") }}</p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <!-- Day 1 Card -->
            <BaseCard padding="lg" class="flex flex-col gap-4 min-h-[280px]">
                <div class="flex items-center gap-3">
                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-surface-sunken">
                        <span class="body-small-bold text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.dayOne.number") }}</span>
                    </div>
                    <h3 class="title-body text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.dayOne.title") }}</h3>
                </div>

                <div class="flex-1 flex flex-col items-center justify-center text-center gap-3 py-4">
                    <div class="text-3xl text-ink-muted"><i class="bi bi-chat-dots" aria-hidden="true"></i></div>
                    <p class="body text-ink-muted italic">{{ t("onboarding.evaluator.contextDeepDive.dayOne.message") }}</p>
                </div>
            </BaseCard>

            <!-- Day 60 Card -->
            <BaseCard padding="lg" class="flex flex-col gap-4 min-h-[280px]">
                <div class="flex items-center gap-3">
                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-surface-sunken">
                        <span class="body-small-bold text-ink">{{ t("onboarding.evaluator.contextDeepDive.daySixty.number") }}</span>
                    </div>
                    <h3 class="title-body text-ink">{{ t("onboarding.evaluator.contextDeepDive.daySixty.title") }}</h3>
                </div>

                <div class="flex-1 flex flex-col items-center justify-center text-center gap-3 py-4">
                    <div class="text-3xl text-chip-nadia-text"><i class="bi bi-stars" aria-hidden="true"></i></div>
                    <p class="body text-ink italic">{{ t("onboarding.evaluator.contextDeepDive.daySixty.message") }}</p>
                    <div class="flex flex-wrap justify-center gap-2 mt-2">
                        <SourceChip class="text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.daySixty.sources.workingStyle") }}</SourceChip>
                        <SourceChip class="text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.daySixty.sources.jordanProfile") }}</SourceChip>
                        <SourceChip class="text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.daySixty.sources.calendar") }}</SourceChip>
                        <SourceChip class="text-ink-muted">{{ t("onboarding.evaluator.contextDeepDive.daySixty.sources.pastSessions") }}</SourceChip>
                    </div>
                </div>
            </BaseCard>
        </div>

        <div class="flex items-center gap-4 mt-2">
            <BaseButton theme="tertiary" @click="emit('back')"> <i class="bi bi-arrow-left mr-1" aria-hidden="true"></i> {{ t("onboarding.evaluator.shared.back") }} </BaseButton>
            <BaseButton theme="primary" class="w-60" @click="emit('next')"> {{ t("onboarding.evaluator.contextDeepDive.continue") }} </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import SourceChip from "~vue/components/SourceChip.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits<{
    next: [];
    back: [];
}>();
</script>
